var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.8V12H12V0H2C0.9 0 0 0.8 0 1.8Z",
    fill: "#465867"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V24H2C0.9 24 0 23.2 0 22.2V12H12Z",
    fill: "#FF7300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00009 6.8862C5.99978 6.88646 6.00039 6.8859 6.00009 6.8862C8.0162 3.826 12.2984 2.49057 15.9329 3.17571L15.9329 6.54724C13.7752 6.46668 9.74532 6.35856 6.79867 6.53013C6.48703 6.54827 6.20748 6.68116 6.00009 6.8862Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00009 6.8862C6.00039 6.8859 5.99978 6.88646 6.00009 6.8862ZM6.00009 6.8862C8.0162 3.826 12.2984 2.49057 15.9329 3.17571L15.9329 6.54724C13.7752 6.46668 9.74532 6.35856 6.79867 6.53013C6.48703 6.54827 6.20748 6.68116 6.00009 6.8862Z",
    stroke: "#465867",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 5.5,
    width: 13.7406,
    height: 16.85,
    rx: 1.5,
    fill: "#E8E8E8",
    stroke: "#465867"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5122 18.725L12 18.725",
    stroke: "#465867",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15.725C14.8807 15.725 16 14.6057 16 13.225C16 11.8443 14.8807 10.725 13.5 10.725C12.1193 10.725 11 11.8443 11 13.225C11 14.6057 12.1193 15.725 13.5 15.725Z",
    fill: "#E8E8E8",
    stroke: "#465867",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8654 14.1865C12.0439 14.1865 12.2151 14.1156 12.3413 13.9894C12.4675 13.8632 12.5384 13.692 12.5384 13.5135V12.9365C12.5384 12.758 12.6093 12.5868 12.7356 12.4606C12.8618 12.3344 13.033 12.2635 13.2115 12.2635C13.39 12.2635 13.5612 12.1926 13.6874 12.0663C13.8137 11.9401 13.8846 11.7689 13.8846 11.5904V10.7544C13.7592 10.735 13.6308 10.725 13.5 10.725C12.1193 10.725 11 11.8443 11 13.225C11 13.5657 11.0681 13.8905 11.1916 14.1865H11.8654Z",
    fill: "white",
    stroke: "#465867",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 13.1864C15.8072 13.0866 15.5937 13.0339 15.3769 13.0327H14.5576C14.3791 13.0327 14.2079 13.1036 14.0817 13.2298C13.9555 13.3561 13.8846 13.5273 13.8846 13.7058C13.8846 13.8843 13.9555 14.0555 14.0817 14.1817C14.2079 14.3079 14.3791 14.3789 14.5576 14.3789C14.6851 14.3789 14.8074 14.4295 14.8976 14.5197C14.9877 14.6098 15.0384 14.7321 15.0384 14.8596V15.1942H15.0403C15.6209 14.7395 15.9953 14.0335 15.9999 13.2399V13.2101C15.9999 13.2022 15.9998 13.1943 15.9997 13.1864Z",
    fill: "white",
    stroke: "#465867",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.4c5d151417f37148e63d3d023526d9a7.svg";
export { ForwardRef as ReactComponent };